// ShippingBanner.js
import React, { useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const ShippingBanner = () => {
  const { t } = useTranslation();
  const ref = useRef(null);

  // Publish height to a CSS var so other components (NavBar) can read it
  useLayoutEffect(() => {
    const setHeightVar = () => {
      const h = ref.current ? ref.current.offsetHeight : 0;
      document.documentElement.style.setProperty(
        "--shipping-banner-height",
        `${h}px`
      );
    };
    setHeightVar();
    // Update on resize & font load
    window.addEventListener("resize", setHeightVar);
    document.fonts?.addEventListener?.("loadingdone", setHeightVar);
    return () => {
      window.removeEventListener("resize", setHeightVar);
      document.fonts?.removeEventListener?.("loadingdone", setHeightVar);
    };
  }, []);

  return (
    <div
      ref={ref}
      style={{
        position: "sticky",
        top: 0,
        background: "#4B3D36",
        color: "#fff",
        textAlign: "center",
        fontFamily: "Didot Regular",
        fontSize: "12px",
        padding: "14px 0",
        letterSpacing: "0.3px",
        zIndex: 99,
      }}
    >
      {t("Delivery to everywhere in Gabon - 4 Days")}
    </div>
  );
};

export default ShippingBanner;
